// extracted by mini-css-extract-plugin
export default {"parse-test-page-form":"style_parse-test-page-form__khGfo"};